import {
  InscribirseComponent, 
  TieneUsuarioYReproComponent,
  DerivacionesComponent,
  ConfirmarUsuarioClaveComponent,
  MenuPrincipalComponent,
  PacientesComponent
} from './components';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms'; 
import { HttpClientModule } from '@angular/common/http';  // Importa HttpClientModule
import {SharedModule} from 'src/app/shared/shared.module';

export const COMPONENTS = [
    InscribirseComponent,
    TieneUsuarioYReproComponent,
    DerivacionesComponent,
    ConfirmarUsuarioClaveComponent,
    MenuPrincipalComponent,
    PacientesComponent
];

export const IMPORTS = [
  SharedModule,
  FormsModule,
  HttpClientModule,
  ReactiveFormsModule
];

export const SERVICES = [];

export const EXPORTS = [];
